
  var _styles = {
  "city-order-task-wrap": {
    "marginTop": "0.48rem"
  },
  "city-order-task-module": {
    "display": "flex",
    "flexDirection": "column",
    "alignItems": "center",
    "justifyContent": "center",
    "position": "relative"
  },
  "city-order-task-module__bg": {
    "display": "flex",
    "alignItems": "center",
    "width": "9.36rem",
    "height": "8.69333rem",
    "borderRadius": "0.48rem",
    "flexDirection": "column"
  },
  "city-order-task-module__light-text": {
    "fontWeight": "400",
    "color": "rgb(36,129,32)",
    "fontFamily": "PingFang SC",
    "fontSize": "0.32rem",
    "lineHeight": "0.37333rem",
    "marginTop": "0.29333rem",
    "marginBottom": "0.29333rem",
    "zIndex": 1
  },
  "city-order-task-module__city-list": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "width": "100%",
    "height": "5.28rem"
  },
  "city-order-task-module__buttons": {
    "width": "100%",
    "height": "1.2rem",
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "justifyContent": "center",
    "marginTop": "0.57333rem"
  },
  "city-order-task-module__wish-button-wrap": {
    "position": "relative",
    "height": "1.2rem",
    "width": "3.24rem",
    "marginRight": "0.24rem"
  },
  "city-order-task-module__wish-wrap": {
    "display": "flex",
    "flexDirection": "row",
    "justifyContent": "center",
    "height": "0.50667rem",
    "backgroundColor": "rgb(235,255,224)",
    "borderTopLeftRadius": "0.33333rem",
    "borderTopRightRadius": "0.25333rem",
    "borderBottomRightRadius": "0.25333rem",
    "borderBottomLeftRadius": "0.08rem"
  },
  "city-order-task-module__wish-tip": {
    "display": "flex",
    "height": "0.50667rem",
    "position": "absolute",
    "top": "-0.22667rem",
    "right": 0,
    "justifyContent": "center"
  },
  "city-order-task-module__wish-tip-text": {
    "fontWeight": "400",
    "color": "rgb(30,138,25)",
    "fontFamily": "PingFang SC",
    "fontSize": "0.26667rem",
    "lineHeight": "0.50667rem",
    "zIndex": 1,
    "textAlign": "center",
    "paddingTop": 0,
    "paddingRight": "0.13333rem",
    "paddingBottom": 0,
    "paddingLeft": "0.13333rem"
  },
  "city-order-task-module__wish-button": {
    "width": "3.24rem",
    "height": "1.2rem",
    "borderRadius": "1.2rem",
    "borderWidth": "0.02667rem",
    "borderStyle": "solid",
    "borderColor": "rgb(30,138,25)",
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "justifyContent": "center"
  },
  "city-order-task-module__wish-text": {
    "color": "rgb(30,138,25)",
    "fontFamily": "PingFang SC",
    "fontWeight": "500",
    "fontSize": "0.42667rem",
    "lineHeight": "0.64rem",
    "textAlign": "center"
  },
  "city-order-task-module__order-button-wrap": {
    "position": "relative",
    "height": "1.2rem",
    "width": "5.24rem"
  },
  "city-order-task-module__order-tip": {
    "height": "0.50667rem",
    "position": "absolute",
    "top": "-0.22667rem",
    "right": 0,
    "zIndex": 1
  },
  "city-order-task-module__order-tip-text": {
    "fontWeight": "400",
    "color": "rgb(255,255,255)",
    "fontFamily": "PingFang SC",
    "fontSize": "0.26667rem",
    "lineHeight": "0.50667rem",
    "textAlign": "center",
    "paddingTop": 0,
    "paddingRight": "0.13333rem",
    "paddingBottom": 0,
    "paddingLeft": "0.13333rem"
  },
  "city-order-task-module__order-button": {
    "width": "5.24rem",
    "height": "1.2rem",
    "borderRadius": "1.2rem",
    "borderWidth": "0.02667rem",
    "borderStyle": "solid",
    "borderColor": "rgb(194,194,194)",
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "justifyContent": "center"
  },
  "city-order-task-module__order-text": {
    "color": "rgb(17,17,17)",
    "fontFamily": "PingFang SC",
    "fontWeight": "500",
    "fontSize": "0.42667rem",
    "lineHeight": "1.2rem",
    "zIndex": 1,
    "textAlign": "center"
  },
  "city-car-item__single": {
    "marginTop": "0.33333rem"
  },
  "loading-cntr": {
    "position": "absolute",
    "top": 0,
    "left": 0,
    "bottom": 0,
    "right": 0,
    "zIndex": 100
  },
  "free-order-result": {
    "display": "flex",
    "alignItems": "center"
  },
  "free-order-result-main-container": {
    "display": "flex",
    "flexDirection": "column",
    "alignItems": "center",
    "position": "relative"
  },
  "free-order-result-order-info": {
    "width": "8rem",
    "color": "rgb(85,85,85)",
    "fontFamily": "PingFang SC",
    "fontWeight": "400",
    "fontSize": "0.32rem",
    "lineHeight": "0.45333rem",
    "textAlign": "center",
    "marginTop": "0.44rem"
  },
  "free-order-result-amount-container": {
    "marginTop": "-0.32rem",
    "marginBottom": "-0.32rem",
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "baseline",
    "justifyContent": "center",
    "position": "relative"
  },
  "free-order-result-amount-symbol": {
    "color": "rgb(17,17,17)",
    "fontFamily": "PingFang SC",
    "fontWeight": "600",
    "fontSize": "0.8rem",
    "lineHeight": "1.06667rem",
    "marginRight": "0.06667rem"
  },
  "free-order-result-amount-value": {
    "color": "rgb(17,17,17)",
    "fontSize": "1.86667rem",
    "lineHeight": "2.2rem",
    "textAlign": "center",
    "position": "relative"
  },
  "free-order-result-tip": {
    "marginTop": "0.2rem",
    "color": "rgb(85,85,85)",
    "fontFamily": "PingFang SC",
    "fontSize": "0.32rem",
    "lineHeight": "0.45333rem",
    "textAlign": "center",
    "maxWidth": "6.66667rem"
  },
  "free-order-result-share-btn": {
    "marginTop": "0.78667rem",
    "width": "5.09333rem",
    "height": "1.46667rem",
    "borderRadius": "1.46667rem",
    "display": "flex",
    "alignItems": "center",
    "justifyContent": "center",
    "position": "relative"
  }
};



  module.exports = _styles;
  